import React, { useState, useRef, useEffect } from 'react';
import { FaAngleRight } from 'react-icons/fa6';
import { useNavigate } from "react-router-dom";
import './MobileLeftSidebar.scss';

export default function MobileLeftSidebar({
    menuData,
    mobileHamburgerMenu,
    setMobileHamburgerMenu,
    isMobile,
    menuClicked,
    setMenuClicked
}) {
    const navigate = useNavigate();
    const [expandedGroups, setExpandedGroups] = useState({});
    const [expandedCategories, setExpandedCategories] = useState({});
    const submenuRefs = useRef({});
    const categoryRefs = useRef({});
    const [pxHeightTotal, setPxHeightTotal] = useState({});

    const toggleGroup = (category, label) => {
        const key = `${category}-${label}`;
        setExpandedGroups((prev) => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const toggleCategory = (category) => {
        setExpandedCategories((prev) => ({
            ...prev,
            [category]: !prev[category]
        }));
    };

    useEffect(() => {
        const newHeights = {};

        Object.entries(menuData).forEach(([category, items]) => {
            let totalHeight = 0;

            if (expandedCategories[category]) {
                const categoryEl = categoryRefs.current[category];
                if (categoryEl) {
                    totalHeight += categoryEl.scrollHeight;
                }

                items.forEach((item) => {
                    const key = `${category}-${item.label}`;
                    const submenuEl = submenuRefs.current[key];
                    if (submenuEl && expandedGroups[key]) {
                        totalHeight += submenuEl.scrollHeight;
                    }
                });
            }

            newHeights[category] = `${totalHeight}px`;
        });

        setPxHeightTotal(newHeights);
    }, [expandedCategories, expandedGroups, menuData]);

    return (
        <>
            {isMobile && mobileHamburgerMenu && (
                <div
                    className="sidebar-backdrop"
                    onClick={() => {
                        setMenuClicked(!menuClicked);
                        setMobileHamburgerMenu(!mobileHamburgerMenu);
                    }}
                />
            )}

            <div className={`mobile-left-sidebar ${mobileHamburgerMenu ? 'open' : ''}`}>
                <div className="sidebar-header">
                    <h2>Menu</h2>
                    <div
                        id="nav-icon2"
                        className={`${menuClicked ? 'open' : ''}`}
                        style={{ color: 'white' }}
                        onClick={() => {
                            setMenuClicked(!menuClicked);
                            setMobileHamburgerMenu(!mobileHamburgerMenu);
                        }}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <div className="sidebar-content">
                    {Object.entries(menuData).map(([category, items], index) => {
                        const isCategoryExpanded = expandedCategories[category];

                        return (
                            <div className="menu-section" key={index}>
                                <div
                                    className="category-title"
                                    onClick={() => toggleCategory(category)}
                                >
                                    {category.toUpperCase()}
                                </div>

                                <div
                                    ref={(el) => (categoryRefs.current[category] = el)}
                                    className="category-group"
                                    style={{
                                        maxHeight: isCategoryExpanded ? pxHeightTotal[category] || '0px' : '0px',
                                        overflow: 'hidden',
                                        transition: 'max-height 0.35s ease'
                                    }}
                                >
                                    {items.map((item, idx) => {
                                        const key = `${category}-${item.label}`;
                                        const isExpanded = expandedGroups[key];

                                        return (
                                            <div key={idx} className="menu-group">
                                                <div
                                                    className="menu-label"
                                                    onClick={() => toggleGroup(category, item.label)}
                                                >
                                                    {item.label}
                                                    <FaAngleRight
                                                        className={`submenu-icon ${isExpanded ? 'rotated' : ''}`}
                                                    />
                                                </div>

                                                <ul
                                                    ref={(el) => (submenuRefs.current[key] = el)}
                                                    className="submenu-list"
                                                    style={{
                                                        maxHeight: isExpanded ? `${submenuRefs.current[key]?.scrollHeight || 0}px` : '0px',
                                                        overflow: 'hidden',
                                                        transition: 'max-height 0.35s ease'
                                                    }}
                                                >
                                                    {item.submenus.map((submenu, subIdx) => (
                                                        <li key={subIdx} className="submenu-item">
                                                            <a onClick={() => navigate(submenu.path)}>
                                                                {submenu.label}
                                                                <FaAngleRight className="submenu-icon" />
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}